import '@ids/style-card';
import './LinkItem.css';

import { Ui32ArrowSmRight } from '@ids/react-icons';

import { IdsIcon } from '../../components/icon/Icon';
import type { Action, Content } from '../../global-types/Content';
import { useHandleCallback } from '../../hooks/useHandleCallback';

type LinkItemProps = {
  content: Content;
  dispatchActionEvent: (action: Action) => void;
};

function LinkItem({ content, dispatchActionEvent }: LinkItemProps) {
  const viewElements = content.contentViews?.[0].viewElements;
  const { mutate: sendCallback } = useHandleCallback();
  if (viewElements === undefined) return null;

  const action = viewElements.actions?.[0];

  function handleOnClick(action: Action) {
    if (action.callback)
      sendCallback({
        url: `${action.callback.baseUrl ?? ''}${action.callback.callbackPath}`,
        payload: action.callback.payload,
      });
    dispatchActionEvent(action);
  }

  return (
    <li className="if list-style-none flex">
      <div className="if  justify-content-space-between size-w-100p flex">
        {action && (
          <a
            key={action.text}
            className={`if link standalone icon quiet`}
            href={action.url ? action.url : ''}
            target={action.target ?? '_self'}
            onClick={() => handleOnClick(action)}
          >
            <div className="if flex align-items-center gap-16">
              {viewElements.icons && (
                <div className="link-icon">
                  <IdsIcon name={viewElements.icons[0]} size={32} />
                </div>
              )}
              <div className="if ui typography large">{action.text}</div>
            </div>
            <div className="if flex align-self-center">
              <Ui32ArrowSmRight />
            </div>
          </a>
        )}
      </div>
    </li>
  );
}
export default LinkItem;
